/**
 * This is a generated file, you probably don't want to change it directly
 * Run `yarn canoe:generate-icons`
 *
 * See Icons.tsx.template and app/canoe/scripts/icons.js for more detail
 */
import React from 'react';

import ABSettings from '!!react-svg-loader!./assets/ABSettings.svg';
import Academy from '!!react-svg-loader!./assets/Academy.svg';
import AlertDanger from '!!react-svg-loader!./assets/AlertDanger.svg';
import AlertInfo from '!!react-svg-loader!./assets/AlertInfo.svg';
import AlertSuccess from '!!react-svg-loader!./assets/AlertSuccess.svg';
import AlertWarning from '!!react-svg-loader!./assets/AlertWarning.svg';
import Announcement from '!!react-svg-loader!./assets/Announcement.svg';
import Archived from '!!react-svg-loader!./assets/Archived.svg';
import Arrow from '!!react-svg-loader!./assets/Arrow.svg';
import ArrowFillDown from '!!react-svg-loader!./assets/ArrowFillDown.svg';
import ArrowFillLeft from '!!react-svg-loader!./assets/ArrowFillLeft.svg';
import ArrowFillRight from '!!react-svg-loader!./assets/ArrowFillRight.svg';
import ArrowFillUp from '!!react-svg-loader!./assets/ArrowFillUp.svg';
import ArrowLeft from '!!react-svg-loader!./assets/ArrowLeft.svg';
import ArrowRight from '!!react-svg-loader!./assets/ArrowRight.svg';
import ArrowUp from '!!react-svg-loader!./assets/ArrowUp.svg';
import Avoid from '!!react-svg-loader!./assets/Avoid.svg';
import Baseline from '!!react-svg-loader!./assets/Baseline.svg';
import Block from '!!react-svg-loader!./assets/Block.svg';
import BlockView from '!!react-svg-loader!./assets/BlockView.svg';
import Boat from '!!react-svg-loader!./assets/Boat.svg';
import Bold from '!!react-svg-loader!./assets/Bold.svg';
import BorderAll from '!!react-svg-loader!./assets/BorderAll.svg';
import BorderBottom from '!!react-svg-loader!./assets/BorderBottom.svg';
import BorderLeft from '!!react-svg-loader!./assets/BorderLeft.svg';
import BorderRight from '!!react-svg-loader!./assets/BorderRight.svg';
import BorderTop from '!!react-svg-loader!./assets/BorderTop.svg';
import BottomAlign from '!!react-svg-loader!./assets/BottomAlign.svg';
import Break from '!!react-svg-loader!./assets/Break.svg';
import Bug from '!!react-svg-loader!./assets/Bug.svg';
import BulletNumbers from '!!react-svg-loader!./assets/BulletNumbers.svg';
import Bullets from '!!react-svg-loader!./assets/Bullets.svg';
import Buttons from '!!react-svg-loader!./assets/Buttons.svg';
import CalendarIcon from '!!react-svg-loader!./assets/CalendarIcon.svg';
import Callout from '!!react-svg-loader!./assets/Callout.svg';
import Callout1 from '!!react-svg-loader!./assets/Callout1.svg';
import Camera from '!!react-svg-loader!./assets/Camera.svg';
import CanduLogo from '!!react-svg-loader!./assets/CanduLogo.svg';
import CanduTypo from '!!react-svg-loader!./assets/CanduTypo.svg';
import Cards from '!!react-svg-loader!./assets/Cards.svg';
import CenterAlign from '!!react-svg-loader!./assets/CenterAlign.svg';
import Check from '!!react-svg-loader!./assets/Check.svg';
import CheckboxInput from '!!react-svg-loader!./assets/CheckboxInput.svg';
import Checklist from '!!react-svg-loader!./assets/Checklist.svg';
import CircleArrow from '!!react-svg-loader!./assets/CircleArrow.svg';
import CircleBullet from '!!react-svg-loader!./assets/CircleBullet.svg';
import CircleFrame from '!!react-svg-loader!./assets/CircleFrame.svg';
import Clock from '!!react-svg-loader!./assets/Clock.svg';
import Close from '!!react-svg-loader!./assets/Close.svg';
import Code from '!!react-svg-loader!./assets/Code.svg';
import Collection from '!!react-svg-loader!./assets/Collection.svg';
import CollectionList from '!!react-svg-loader!./assets/CollectionList.svg';
import Computer from '!!react-svg-loader!./assets/Computer.svg';
import Containers from '!!react-svg-loader!./assets/Containers.svg';
import ContentHotspots from '!!react-svg-loader!./assets/ContentHotspots.svg';
import ContentInline from '!!react-svg-loader!./assets/ContentInline.svg';
import ContentModal from '!!react-svg-loader!./assets/ContentModal.svg';
import ContentTours from '!!react-svg-loader!./assets/ContentTours.svg';
import ConversationIcon from '!!react-svg-loader!./assets/ConversationIcon.svg';
import CornerRightDown from '!!react-svg-loader!./assets/CornerRightDown.svg';
import Crop from '!!react-svg-loader!./assets/Crop.svg';
import Crossed from '!!react-svg-loader!./assets/Crossed.svg';
import Custom from '!!react-svg-loader!./assets/Custom.svg';
import CustomCode from '!!react-svg-loader!./assets/CustomCode.svg';
import CustomerService from '!!react-svg-loader!./assets/CustomerService.svg';
import Danger from '!!react-svg-loader!./assets/Danger.svg';
import DataEntry from '!!react-svg-loader!./assets/DataEntry.svg';
import Diagram from '!!react-svg-loader!./assets/Diagram.svg';
import DoubleLine from '!!react-svg-loader!./assets/DoubleLine.svg';
import Down from '!!react-svg-loader!./assets/Down.svg';
import Download from '!!react-svg-loader!./assets/Download.svg';
import DropdownInput from '!!react-svg-loader!./assets/DropdownInput.svg';
import Duplicate from '!!react-svg-loader!./assets/Duplicate.svg';
import EdgeAlign from '!!react-svg-loader!./assets/EdgeAlign.svg';
import Edit from '!!react-svg-loader!./assets/Edit.svg';
import Ellipsis from '!!react-svg-loader!./assets/Ellipsis.svg';
import EllipsisH from '!!react-svg-loader!./assets/EllipsisH.svg';
import Embed from '!!react-svg-loader!./assets/Embed.svg';
import Enter from '!!react-svg-loader!./assets/Enter.svg';
import ExitIcon from '!!react-svg-loader!./assets/ExitIcon.svg';
import Expand from '!!react-svg-loader!./assets/Expand.svg';
import Experiments from '!!react-svg-loader!./assets/Experiments.svg';
import ExternalLink from '!!react-svg-loader!./assets/ExternalLink.svg';
import Filter from '!!react-svg-loader!./assets/Filter.svg';
import Flex from '!!react-svg-loader!./assets/Flex.svg';
import Form from '!!react-svg-loader!./assets/Form.svg';
import FormField from '!!react-svg-loader!./assets/FormField.svg';
import Gear from '!!react-svg-loader!./assets/Gear.svg';
import Goals from '!!react-svg-loader!./assets/Goals.svg';
import Graph from '!!react-svg-loader!./assets/Graph.svg';
import Groups from '!!react-svg-loader!./assets/Groups.svg';
import Growth from '!!react-svg-loader!./assets/Growth.svg';
import Handles from '!!react-svg-loader!./assets/Handles.svg';
import Help from '!!react-svg-loader!./assets/Help.svg';
import Hidden from '!!react-svg-loader!./assets/Hidden.svg';
import Hint from '!!react-svg-loader!./assets/Hint.svg';
import Hourglass from '!!react-svg-loader!./assets/Hourglass.svg';
import Image from '!!react-svg-loader!./assets/Image.svg';
import ImgFill from '!!react-svg-loader!./assets/ImgFill.svg';
import ImgFit from '!!react-svg-loader!./assets/ImgFit.svg';
import ImgStrech from '!!react-svg-loader!./assets/ImgStrech.svg';
import Info from '!!react-svg-loader!./assets/Info.svg';
import Interactive from '!!react-svg-loader!./assets/Interactive.svg';
import Italic from '!!react-svg-loader!./assets/Italic.svg';
import Layer from '!!react-svg-loader!./assets/Layer.svg';
import Layout from '!!react-svg-loader!./assets/Layout.svg';
import LayoutBlock from '!!react-svg-loader!./assets/LayoutBlock.svg';
import LayoutFlex from '!!react-svg-loader!./assets/LayoutFlex.svg';
import LayoutGrid from '!!react-svg-loader!./assets/LayoutGrid.svg';
import LayoutInlineBlock from '!!react-svg-loader!./assets/LayoutInlineBlock.svg';
import LeftAlign from '!!react-svg-loader!./assets/LeftAlign.svg';
import LifeGuard from '!!react-svg-loader!./assets/LifeGuard.svg';
import Lightning from '!!react-svg-loader!./assets/Lightning.svg';
import Line from '!!react-svg-loader!./assets/Line.svg';
import LinkBroken from '!!react-svg-loader!./assets/LinkBroken.svg';
import LinkUnbroken from '!!react-svg-loader!./assets/LinkUnbroken.svg';
import Lock from '!!react-svg-loader!./assets/Lock.svg';
import Logout from '!!react-svg-loader!./assets/Logout.svg';
import MagicWand from '!!react-svg-loader!./assets/MagicWand.svg';
import Map from '!!react-svg-loader!./assets/Map.svg';
import MeasureIcon from '!!react-svg-loader!./assets/MeasureIcon.svg';
import Menu from '!!react-svg-loader!./assets/Menu.svg';
import Merge from '!!react-svg-loader!./assets/Merge.svg';
import Mesurement from '!!react-svg-loader!./assets/Mesurement.svg';
import MiddleAlign from '!!react-svg-loader!./assets/MiddleAlign.svg';
import Mobile from '!!react-svg-loader!./assets/Mobile.svg';
import Move from '!!react-svg-loader!./assets/Move.svg';
import MultiSelectCard from '!!react-svg-loader!./assets/MultiSelectCard.svg';
import NewTab from '!!react-svg-loader!./assets/NewTab.svg';
import NextArrow from '!!react-svg-loader!./assets/NextArrow.svg';
import NextLine from '!!react-svg-loader!./assets/NextLine.svg';
import Notifications from '!!react-svg-loader!./assets/Notifications.svg';
import NumberBullet from '!!react-svg-loader!./assets/NumberBullet.svg';
import Object from '!!react-svg-loader!./assets/Object.svg';
import Paintbrush from '!!react-svg-loader!./assets/Paintbrush.svg';
import Paste from '!!react-svg-loader!./assets/Paste.svg';
import PasteInside from '!!react-svg-loader!./assets/PasteInside.svg';
import People from '!!react-svg-loader!./assets/People.svg';
import Picture from '!!react-svg-loader!./assets/Picture.svg';
import Placement from '!!react-svg-loader!./assets/Placement.svg';
import PlayCircle from '!!react-svg-loader!./assets/PlayCircle.svg';
import Plus from '!!react-svg-loader!./assets/Plus.svg';
import Plus1 from '!!react-svg-loader!./assets/Plus1.svg';
import PlusBullet from '!!react-svg-loader!./assets/PlusBullet.svg';
import PointHand from '!!react-svg-loader!./assets/PointHand.svg';
import PortalIcon from '!!react-svg-loader!./assets/PortalIcon.svg';
import Preview from '!!react-svg-loader!./assets/Preview.svg';
import PreviousArrow from '!!react-svg-loader!./assets/PreviousArrow.svg';
import ProfileIcon from '!!react-svg-loader!./assets/ProfileIcon.svg';
import PuzleIcon from '!!react-svg-loader!./assets/PuzleIcon.svg';
import Puzzle1Piece from '!!react-svg-loader!./assets/Puzzle1Piece.svg';
import Quote from '!!react-svg-loader!./assets/Quote.svg';
import RadiusAll from '!!react-svg-loader!./assets/RadiusAll.svg';
import RadiusBottomLeft from '!!react-svg-loader!./assets/RadiusBottomLeft.svg';
import RadiusBottomRight from '!!react-svg-loader!./assets/RadiusBottomRight.svg';
import RadiusTopLeft from '!!react-svg-loader!./assets/RadiusTopLeft.svg';
import RadiusTopRight from '!!react-svg-loader!./assets/RadiusTopRight.svg';
import Recent from '!!react-svg-loader!./assets/Recent.svg';
import Redo from '!!react-svg-loader!./assets/Redo.svg';
import RightAlign from '!!react-svg-loader!./assets/RightAlign.svg';
import Rocket from '!!react-svg-loader!./assets/Rocket.svg';
import RombusFrame from '!!react-svg-loader!./assets/RombusFrame.svg';
import ScaleInput from '!!react-svg-loader!./assets/ScaleInput.svg';
import Scissor from '!!react-svg-loader!./assets/Scissor.svg';
import Scroll from '!!react-svg-loader!./assets/Scroll.svg';
import Search from '!!react-svg-loader!./assets/Search.svg';
import Security from '!!react-svg-loader!./assets/Security.svg';
import Segments from '!!react-svg-loader!./assets/Segments.svg';
import SelectIconChat from '!!react-svg-loader!./assets/SelectIconChat.svg';
import SelectIconGear from '!!react-svg-loader!./assets/SelectIconGear.svg';
import SelectIconInfo from '!!react-svg-loader!./assets/SelectIconInfo.svg';
import SelectIconRocket from '!!react-svg-loader!./assets/SelectIconRocket.svg';
import SelectIconStar from '!!react-svg-loader!./assets/SelectIconStar.svg';
import SelectIconThumbs from '!!react-svg-loader!./assets/SelectIconThumbs.svg';
import ShakingHands from '!!react-svg-loader!./assets/ShakingHands.svg';
import Share from '!!react-svg-loader!./assets/Share.svg';
import Shown from '!!react-svg-loader!./assets/Shown.svg';
import SingleLine from '!!react-svg-loader!./assets/SingleLine.svg';
import SingleSelectCard from '!!react-svg-loader!./assets/SingleSelectCard.svg';
import Snapshot from '!!react-svg-loader!./assets/Snapshot.svg';
import Snowflake from '!!react-svg-loader!./assets/Snowflake.svg';
import Spacing1 from '!!react-svg-loader!./assets/Spacing1.svg';
import Spacing3 from '!!react-svg-loader!./assets/Spacing3.svg';
import SplitView from '!!react-svg-loader!./assets/SplitView.svg';
import SquareFrame from '!!react-svg-loader!./assets/SquareFrame.svg';
import Star from '!!react-svg-loader!./assets/Star.svg';
import Stars from '!!react-svg-loader!./assets/Stars.svg';
import Stats from '!!react-svg-loader!./assets/Stats.svg';
import Steps from '!!react-svg-loader!./assets/Steps.svg';
import Stretch from '!!react-svg-loader!./assets/Stretch.svg';
import Study from '!!react-svg-loader!./assets/Study.svg';
import Sync from '!!react-svg-loader!./assets/Sync.svg';
import Tablet from '!!react-svg-loader!./assets/Tablet.svg';
import Target from '!!react-svg-loader!./assets/Target.svg';
import Telescope from '!!react-svg-loader!./assets/Telescope.svg';
import Template from '!!react-svg-loader!./assets/Template.svg';
import Text from '!!react-svg-loader!./assets/Text.svg';
import TextInput from '!!react-svg-loader!./assets/TextInput.svg';
import TextLeft from '!!react-svg-loader!./assets/TextLeft.svg';
import TextMiddle from '!!react-svg-loader!./assets/TextMiddle.svg';
import TextRight from '!!react-svg-loader!./assets/TextRight.svg';
import ThreePeopleIcon from '!!react-svg-loader!./assets/ThreePeopleIcon.svg';
import Thumbs from '!!react-svg-loader!./assets/Thumbs.svg';
import Tick from '!!react-svg-loader!./assets/Tick.svg';
import Tick1 from '!!react-svg-loader!./assets/Tick1.svg';
import TickBullet from '!!react-svg-loader!./assets/TickBullet.svg';
import TimeIcon from '!!react-svg-loader!./assets/TimeIcon.svg';
import Tools from '!!react-svg-loader!./assets/Tools.svg';
import TopAlign from '!!react-svg-loader!./assets/TopAlign.svg';
import Trash from '!!react-svg-loader!./assets/Trash.svg';
import Trophy from '!!react-svg-loader!./assets/Trophy.svg';
import Tutorial from '!!react-svg-loader!./assets/Tutorial.svg';
import Underline from '!!react-svg-loader!./assets/Underline.svg';
import Undo from '!!react-svg-loader!./assets/Undo.svg';
import Ungroup from '!!react-svg-loader!./assets/Ungroup.svg';
import Unify from '!!react-svg-loader!./assets/Unify.svg';
import Union from '!!react-svg-loader!./assets/Union.svg';
import Union1 from '!!react-svg-loader!./assets/Union1.svg';
import Union2 from '!!react-svg-loader!./assets/Union2.svg';
import Unlock from '!!react-svg-loader!./assets/Unlock.svg';
import Unsynced from '!!react-svg-loader!./assets/Unsynced.svg';
import Up from '!!react-svg-loader!./assets/Up.svg';
import UpDown from '!!react-svg-loader!./assets/UpDown.svg';
import Upload from '!!react-svg-loader!./assets/Upload.svg';
import Variable from '!!react-svg-loader!./assets/Variable.svg';
import Watermark from '!!react-svg-loader!./assets/Watermark.svg';
import Workspace from '!!react-svg-loader!./assets/Workspace.svg';
import WrapSameLine from '!!react-svg-loader!./assets/WrapSameLine.svg';
import { SVG } from 'canoe/types/SVG';

import { Icon, IconProps } from './Icon';

type BoundIconProps = Omit<IconProps, 'svg'>;
export type CanoeIcon = (iconProps: BoundIconProps) => JSX.Element;

const IconForSvg = (svg: SVG) => {
  // Strip leading and trailing filename artifacts
  return (iconProps: BoundIconProps) => {
    return <Icon {...iconProps} svg={svg} />;
  };
};

export const ABSettingsIcon = /* #__PURE__ */ IconForSvg(ABSettings);
export const AcademyIcon = /* #__PURE__ */ IconForSvg(Academy);
export const AlertDangerIcon = /* #__PURE__ */ IconForSvg(AlertDanger);
export const AlertInfoIcon = /* #__PURE__ */ IconForSvg(AlertInfo);
export const AlertSuccessIcon = /* #__PURE__ */ IconForSvg(AlertSuccess);
export const AlertWarningIcon = /* #__PURE__ */ IconForSvg(AlertWarning);
export const AnnouncementIcon = /* #__PURE__ */ IconForSvg(Announcement);
export const ArchivedIcon = /* #__PURE__ */ IconForSvg(Archived);
export const ArrowIcon = /* #__PURE__ */ IconForSvg(Arrow);
export const ArrowFillDownIcon = /* #__PURE__ */ IconForSvg(ArrowFillDown);
export const ArrowFillLeftIcon = /* #__PURE__ */ IconForSvg(ArrowFillLeft);
export const ArrowFillRightIcon = /* #__PURE__ */ IconForSvg(ArrowFillRight);
export const ArrowFillUpIcon = /* #__PURE__ */ IconForSvg(ArrowFillUp);
export const ArrowLeftIcon = /* #__PURE__ */ IconForSvg(ArrowLeft);
export const ArrowRightIcon = /* #__PURE__ */ IconForSvg(ArrowRight);
export const ArrowUpIcon = /* #__PURE__ */ IconForSvg(ArrowUp);
export const AvoidIcon = /* #__PURE__ */ IconForSvg(Avoid);
export const BaselineIcon = /* #__PURE__ */ IconForSvg(Baseline);
export const BlockIcon = /* #__PURE__ */ IconForSvg(Block);
export const BlockViewIcon = /* #__PURE__ */ IconForSvg(BlockView);
export const BoatIcon = /* #__PURE__ */ IconForSvg(Boat);
export const BoldIcon = /* #__PURE__ */ IconForSvg(Bold);
export const BorderAllIcon = /* #__PURE__ */ IconForSvg(BorderAll);
export const BorderBottomIcon = /* #__PURE__ */ IconForSvg(BorderBottom);
export const BorderLeftIcon = /* #__PURE__ */ IconForSvg(BorderLeft);
export const BorderRightIcon = /* #__PURE__ */ IconForSvg(BorderRight);
export const BorderTopIcon = /* #__PURE__ */ IconForSvg(BorderTop);
export const BottomAlignIcon = /* #__PURE__ */ IconForSvg(BottomAlign);
export const BreakIcon = /* #__PURE__ */ IconForSvg(Break);
export const BugIcon = /* #__PURE__ */ IconForSvg(Bug);
export const BulletNumbersIcon = /* #__PURE__ */ IconForSvg(BulletNumbers);
export const BulletsIcon = /* #__PURE__ */ IconForSvg(Bullets);
export const ButtonsIcon = /* #__PURE__ */ IconForSvg(Buttons);
export const CalendarIconIcon = /* #__PURE__ */ IconForSvg(CalendarIcon);
export const CalloutIcon = /* #__PURE__ */ IconForSvg(Callout);
export const Callout1Icon = /* #__PURE__ */ IconForSvg(Callout1);
export const CameraIcon = /* #__PURE__ */ IconForSvg(Camera);
export const CanduLogoIcon = /* #__PURE__ */ IconForSvg(CanduLogo);
export const CanduTypoIcon = /* #__PURE__ */ IconForSvg(CanduTypo);
export const CardsIcon = /* #__PURE__ */ IconForSvg(Cards);
export const CenterAlignIcon = /* #__PURE__ */ IconForSvg(CenterAlign);
export const CheckIcon = /* #__PURE__ */ IconForSvg(Check);
export const CheckboxInputIcon = /* #__PURE__ */ IconForSvg(CheckboxInput);
export const ChecklistIcon = /* #__PURE__ */ IconForSvg(Checklist);
export const CircleArrowIcon = /* #__PURE__ */ IconForSvg(CircleArrow);
export const CircleBulletIcon = /* #__PURE__ */ IconForSvg(CircleBullet);
export const CircleFrameIcon = /* #__PURE__ */ IconForSvg(CircleFrame);
export const ClockIcon = /* #__PURE__ */ IconForSvg(Clock);
export const CloseIcon = /* #__PURE__ */ IconForSvg(Close);
export const CodeIcon = /* #__PURE__ */ IconForSvg(Code);
export const CollectionIcon = /* #__PURE__ */ IconForSvg(Collection);
export const CollectionListIcon = /* #__PURE__ */ IconForSvg(CollectionList);
export const ComputerIcon = /* #__PURE__ */ IconForSvg(Computer);
export const ContainersIcon = /* #__PURE__ */ IconForSvg(Containers);
export const ContentHotspotsIcon = /* #__PURE__ */ IconForSvg(ContentHotspots);
export const ContentInlineIcon = /* #__PURE__ */ IconForSvg(ContentInline);
export const ContentModalIcon = /* #__PURE__ */ IconForSvg(ContentModal);
export const ContentToursIcon = /* #__PURE__ */ IconForSvg(ContentTours);
export const ConversationIconIcon = /* #__PURE__ */ IconForSvg(ConversationIcon);
export const CornerRightDownIcon = /* #__PURE__ */ IconForSvg(CornerRightDown);
export const CropIcon = /* #__PURE__ */ IconForSvg(Crop);
export const CrossedIcon = /* #__PURE__ */ IconForSvg(Crossed);
export const CustomIcon = /* #__PURE__ */ IconForSvg(Custom);
export const CustomCodeIcon = /* #__PURE__ */ IconForSvg(CustomCode);
export const CustomerServiceIcon = /* #__PURE__ */ IconForSvg(CustomerService);
export const DangerIcon = /* #__PURE__ */ IconForSvg(Danger);
export const DataEntryIcon = /* #__PURE__ */ IconForSvg(DataEntry);
export const DiagramIcon = /* #__PURE__ */ IconForSvg(Diagram);
export const DoubleLineIcon = /* #__PURE__ */ IconForSvg(DoubleLine);
export const DownIcon = /* #__PURE__ */ IconForSvg(Down);
export const DownloadIcon = /* #__PURE__ */ IconForSvg(Download);
export const DropdownInputIcon = /* #__PURE__ */ IconForSvg(DropdownInput);
export const DuplicateIcon = /* #__PURE__ */ IconForSvg(Duplicate);
export const EdgeAlignIcon = /* #__PURE__ */ IconForSvg(EdgeAlign);
export const EditIcon = /* #__PURE__ */ IconForSvg(Edit);
export const EllipsisIcon = /* #__PURE__ */ IconForSvg(Ellipsis);
export const EllipsisHIcon = /* #__PURE__ */ IconForSvg(EllipsisH);
export const EmbedIcon = /* #__PURE__ */ IconForSvg(Embed);
export const EnterIcon = /* #__PURE__ */ IconForSvg(Enter);
export const ExitIconIcon = /* #__PURE__ */ IconForSvg(ExitIcon);
export const ExpandIcon = /* #__PURE__ */ IconForSvg(Expand);
export const ExperimentsIcon = /* #__PURE__ */ IconForSvg(Experiments);
export const ExternalLinkIcon = /* #__PURE__ */ IconForSvg(ExternalLink);
export const FilterIcon = /* #__PURE__ */ IconForSvg(Filter);
export const FlexIcon = /* #__PURE__ */ IconForSvg(Flex);
export const FormIcon = /* #__PURE__ */ IconForSvg(Form);
export const FormFieldIcon = /* #__PURE__ */ IconForSvg(FormField);
export const GearIcon = /* #__PURE__ */ IconForSvg(Gear);
export const GoalsIcon = /* #__PURE__ */ IconForSvg(Goals);
export const GraphIcon = /* #__PURE__ */ IconForSvg(Graph);
export const GroupsIcon = /* #__PURE__ */ IconForSvg(Groups);
export const GrowthIcon = /* #__PURE__ */ IconForSvg(Growth);
export const HandlesIcon = /* #__PURE__ */ IconForSvg(Handles);
export const HelpIcon = /* #__PURE__ */ IconForSvg(Help);
export const HiddenIcon = /* #__PURE__ */ IconForSvg(Hidden);
export const HintIcon = /* #__PURE__ */ IconForSvg(Hint);
export const HourglassIcon = /* #__PURE__ */ IconForSvg(Hourglass);
export const ImageIcon = /* #__PURE__ */ IconForSvg(Image);
export const ImgFillIcon = /* #__PURE__ */ IconForSvg(ImgFill);
export const ImgFitIcon = /* #__PURE__ */ IconForSvg(ImgFit);
export const ImgStrechIcon = /* #__PURE__ */ IconForSvg(ImgStrech);
export const InfoIcon = /* #__PURE__ */ IconForSvg(Info);
export const InteractiveIcon = /* #__PURE__ */ IconForSvg(Interactive);
export const ItalicIcon = /* #__PURE__ */ IconForSvg(Italic);
export const LayerIcon = /* #__PURE__ */ IconForSvg(Layer);
export const LayoutIcon = /* #__PURE__ */ IconForSvg(Layout);
export const LayoutBlockIcon = /* #__PURE__ */ IconForSvg(LayoutBlock);
export const LayoutFlexIcon = /* #__PURE__ */ IconForSvg(LayoutFlex);
export const LayoutGridIcon = /* #__PURE__ */ IconForSvg(LayoutGrid);
export const LayoutInlineBlockIcon = /* #__PURE__ */ IconForSvg(LayoutInlineBlock);
export const LeftAlignIcon = /* #__PURE__ */ IconForSvg(LeftAlign);
export const LifeGuardIcon = /* #__PURE__ */ IconForSvg(LifeGuard);
export const LightningIcon = /* #__PURE__ */ IconForSvg(Lightning);
export const LineIcon = /* #__PURE__ */ IconForSvg(Line);
export const LinkBrokenIcon = /* #__PURE__ */ IconForSvg(LinkBroken);
export const LinkUnbrokenIcon = /* #__PURE__ */ IconForSvg(LinkUnbroken);
export const LockIcon = /* #__PURE__ */ IconForSvg(Lock);
export const LogoutIcon = /* #__PURE__ */ IconForSvg(Logout);
export const MagicWandIcon = /* #__PURE__ */ IconForSvg(MagicWand);
export const MapIcon = /* #__PURE__ */ IconForSvg(Map);
export const MeasureIconIcon = /* #__PURE__ */ IconForSvg(MeasureIcon);
export const MenuIcon = /* #__PURE__ */ IconForSvg(Menu);
export const MergeIcon = /* #__PURE__ */ IconForSvg(Merge);
export const MesurementIcon = /* #__PURE__ */ IconForSvg(Mesurement);
export const MiddleAlignIcon = /* #__PURE__ */ IconForSvg(MiddleAlign);
export const MobileIcon = /* #__PURE__ */ IconForSvg(Mobile);
export const MoveIcon = /* #__PURE__ */ IconForSvg(Move);
export const MultiSelectCardIcon = /* #__PURE__ */ IconForSvg(MultiSelectCard);
export const NewTabIcon = /* #__PURE__ */ IconForSvg(NewTab);
export const NextArrowIcon = /* #__PURE__ */ IconForSvg(NextArrow);
export const NextLineIcon = /* #__PURE__ */ IconForSvg(NextLine);
export const NotificationsIcon = /* #__PURE__ */ IconForSvg(Notifications);
export const NumberBulletIcon = /* #__PURE__ */ IconForSvg(NumberBullet);
export const ObjectIcon = /* #__PURE__ */ IconForSvg(Object);
export const PaintbrushIcon = /* #__PURE__ */ IconForSvg(Paintbrush);
export const PasteIcon = /* #__PURE__ */ IconForSvg(Paste);
export const PasteInsideIcon = /* #__PURE__ */ IconForSvg(PasteInside);
export const PeopleIcon = /* #__PURE__ */ IconForSvg(People);
export const PictureIcon = /* #__PURE__ */ IconForSvg(Picture);
export const PlacementIcon = /* #__PURE__ */ IconForSvg(Placement);
export const PlayCircleIcon = /* #__PURE__ */ IconForSvg(PlayCircle);
export const PlusIcon = /* #__PURE__ */ IconForSvg(Plus);
export const Plus1Icon = /* #__PURE__ */ IconForSvg(Plus1);
export const PlusBulletIcon = /* #__PURE__ */ IconForSvg(PlusBullet);
export const PointHandIcon = /* #__PURE__ */ IconForSvg(PointHand);
export const PortalIconIcon = /* #__PURE__ */ IconForSvg(PortalIcon);
export const PreviewIcon = /* #__PURE__ */ IconForSvg(Preview);
export const PreviousArrowIcon = /* #__PURE__ */ IconForSvg(PreviousArrow);
export const ProfileIconIcon = /* #__PURE__ */ IconForSvg(ProfileIcon);
export const PuzleIconIcon = /* #__PURE__ */ IconForSvg(PuzleIcon);
export const Puzzle1PieceIcon = /* #__PURE__ */ IconForSvg(Puzzle1Piece);
export const QuoteIcon = /* #__PURE__ */ IconForSvg(Quote);
export const RadiusAllIcon = /* #__PURE__ */ IconForSvg(RadiusAll);
export const RadiusBottomLeftIcon = /* #__PURE__ */ IconForSvg(RadiusBottomLeft);
export const RadiusBottomRightIcon = /* #__PURE__ */ IconForSvg(RadiusBottomRight);
export const RadiusTopLeftIcon = /* #__PURE__ */ IconForSvg(RadiusTopLeft);
export const RadiusTopRightIcon = /* #__PURE__ */ IconForSvg(RadiusTopRight);
export const RecentIcon = /* #__PURE__ */ IconForSvg(Recent);
export const RedoIcon = /* #__PURE__ */ IconForSvg(Redo);
export const RightAlignIcon = /* #__PURE__ */ IconForSvg(RightAlign);
export const RocketIcon = /* #__PURE__ */ IconForSvg(Rocket);
export const RombusFrameIcon = /* #__PURE__ */ IconForSvg(RombusFrame);
export const ScaleInputIcon = /* #__PURE__ */ IconForSvg(ScaleInput);
export const ScissorIcon = /* #__PURE__ */ IconForSvg(Scissor);
export const ScrollIcon = /* #__PURE__ */ IconForSvg(Scroll);
export const SearchIcon = /* #__PURE__ */ IconForSvg(Search);
export const SecurityIcon = /* #__PURE__ */ IconForSvg(Security);
export const SegmentsIcon = /* #__PURE__ */ IconForSvg(Segments);
export const SelectIconChatIcon = /* #__PURE__ */ IconForSvg(SelectIconChat);
export const SelectIconGearIcon = /* #__PURE__ */ IconForSvg(SelectIconGear);
export const SelectIconInfoIcon = /* #__PURE__ */ IconForSvg(SelectIconInfo);
export const SelectIconRocketIcon = /* #__PURE__ */ IconForSvg(SelectIconRocket);
export const SelectIconStarIcon = /* #__PURE__ */ IconForSvg(SelectIconStar);
export const SelectIconThumbsIcon = /* #__PURE__ */ IconForSvg(SelectIconThumbs);
export const ShakingHandsIcon = /* #__PURE__ */ IconForSvg(ShakingHands);
export const ShareIcon = /* #__PURE__ */ IconForSvg(Share);
export const ShownIcon = /* #__PURE__ */ IconForSvg(Shown);
export const SingleLineIcon = /* #__PURE__ */ IconForSvg(SingleLine);
export const SingleSelectCardIcon = /* #__PURE__ */ IconForSvg(SingleSelectCard);
export const SnapshotIcon = /* #__PURE__ */ IconForSvg(Snapshot);
export const SnowflakeIcon = /* #__PURE__ */ IconForSvg(Snowflake);
export const Spacing1Icon = /* #__PURE__ */ IconForSvg(Spacing1);
export const Spacing3Icon = /* #__PURE__ */ IconForSvg(Spacing3);
export const SplitViewIcon = /* #__PURE__ */ IconForSvg(SplitView);
export const SquareFrameIcon = /* #__PURE__ */ IconForSvg(SquareFrame);
export const StarIcon = /* #__PURE__ */ IconForSvg(Star);
export const StarsIcon = /* #__PURE__ */ IconForSvg(Stars);
export const StatsIcon = /* #__PURE__ */ IconForSvg(Stats);
export const StepsIcon = /* #__PURE__ */ IconForSvg(Steps);
export const StretchIcon = /* #__PURE__ */ IconForSvg(Stretch);
export const StudyIcon = /* #__PURE__ */ IconForSvg(Study);
export const SyncIcon = /* #__PURE__ */ IconForSvg(Sync);
export const TabletIcon = /* #__PURE__ */ IconForSvg(Tablet);
export const TargetIcon = /* #__PURE__ */ IconForSvg(Target);
export const TelescopeIcon = /* #__PURE__ */ IconForSvg(Telescope);
export const TemplateIcon = /* #__PURE__ */ IconForSvg(Template);
export const TextIcon = /* #__PURE__ */ IconForSvg(Text);
export const TextInputIcon = /* #__PURE__ */ IconForSvg(TextInput);
export const TextLeftIcon = /* #__PURE__ */ IconForSvg(TextLeft);
export const TextMiddleIcon = /* #__PURE__ */ IconForSvg(TextMiddle);
export const TextRightIcon = /* #__PURE__ */ IconForSvg(TextRight);
export const ThreePeopleIconIcon = /* #__PURE__ */ IconForSvg(ThreePeopleIcon);
export const ThumbsIcon = /* #__PURE__ */ IconForSvg(Thumbs);
export const TickIcon = /* #__PURE__ */ IconForSvg(Tick);
export const Tick1Icon = /* #__PURE__ */ IconForSvg(Tick1);
export const TickBulletIcon = /* #__PURE__ */ IconForSvg(TickBullet);
export const TimeIconIcon = /* #__PURE__ */ IconForSvg(TimeIcon);
export const ToolsIcon = /* #__PURE__ */ IconForSvg(Tools);
export const TopAlignIcon = /* #__PURE__ */ IconForSvg(TopAlign);
export const TrashIcon = /* #__PURE__ */ IconForSvg(Trash);
export const TrophyIcon = /* #__PURE__ */ IconForSvg(Trophy);
export const TutorialIcon = /* #__PURE__ */ IconForSvg(Tutorial);
export const UnderlineIcon = /* #__PURE__ */ IconForSvg(Underline);
export const UndoIcon = /* #__PURE__ */ IconForSvg(Undo);
export const UngroupIcon = /* #__PURE__ */ IconForSvg(Ungroup);
export const UnifyIcon = /* #__PURE__ */ IconForSvg(Unify);
export const UnionIcon = /* #__PURE__ */ IconForSvg(Union);
export const Union1Icon = /* #__PURE__ */ IconForSvg(Union1);
export const Union2Icon = /* #__PURE__ */ IconForSvg(Union2);
export const UnlockIcon = /* #__PURE__ */ IconForSvg(Unlock);
export const UnsyncedIcon = /* #__PURE__ */ IconForSvg(Unsynced);
export const UpIcon = /* #__PURE__ */ IconForSvg(Up);
export const UpDownIcon = /* #__PURE__ */ IconForSvg(UpDown);
export const UploadIcon = /* #__PURE__ */ IconForSvg(Upload);
export const VariableIcon = /* #__PURE__ */ IconForSvg(Variable);
export const WatermarkIcon = /* #__PURE__ */ IconForSvg(Watermark);
export const WorkspaceIcon = /* #__PURE__ */ IconForSvg(Workspace);
export const WrapSameLineIcon = /* #__PURE__ */ IconForSvg(WrapSameLine);
